import React, { useState, useEffect, useRef, useMemo } from 'react';
import api from './AxiosConfig';
import date from 'date-and-time'; // Moved import to top
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';

//===============================================================
function ReviewGoalRM(props) {
  const [progress, setProgress] = useState();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const getGoalProgress = async () => {
      if (props?.goal?.id && !loaded) {
        try {
          const goalProgress = await api.get(`/site/goals/progress/${encodeURIComponent(props.goal.id)}`, { withCredentials: true });
          setProgress(goalProgress.data);
          setLoaded(true);
        } catch (error) {
          console.log("ReviewGoalDQT: " + error);
        }
      }
    };
    getGoalProgress();
  }, [loaded, props.goal?.id]); // Narrowed deps for efficiency

  // Compute graphData during render (or memoize if expensive)
  //const graphData = useMemo(() => {
  //  const data = [["Date", "Target", "Inst Target", "Actual", "Trend (" + (props.goal?.dqt_predicted_date?.split('T')[0] ?? '') + ")"]];

    //if (progress && progress.length > 0) {
    //  for (const el of progress) {
    //    const ds = date.format(new Date(el.date), "DD/MM");
    //    const tg = el.target_value;
    //    const tr = el.linear_trend;
    //    const ac = el.value ?? NaN;
    //    const it = el.instant_target ?? NaN;
    //    data.push([ds, tg, it, ac, tr]);
    //  }
    //}
  //  return data;
  //}, [progress, props.goal?.dqt_predicted_date]); // Recompute only when these change

  // Compute summary as a variable (derived from progress and props)
  let summary = "To be completed.";
  //if (progress && progress.length > 0) {
    // Assuming delta is calculated in graphData loop; for simplicity, recompute here or extract to a function
    //const lt1 = progress[progress.length - 1].instant_target;
    //const lt2 = progress[progress.length - 2].instant_target;
    //const delta = (lt2 - lt1);
    //const decreasing = props.goal.dqt_target_value < props.goal.dqt_start_value;
    //summary = "To achieve your target you need to ";
    //summary += decreasing ? `lose ${delta.toFixed(2)} ${props.goal.dqt_units} per ` : `gain ${Number(-1 * delta).toFixed(2)} ${props.goal.dqt_units} per `;
    //summary += `${props.goal.sample_period} days. The current average predicts that you will achieve the target on ${props.goal.dqt_predicted_date.split('T')[0]}.`;
  //}

  // Chart options (can stay as-is, or memoize if props change often)
  //const options = {
  //  title: 'Achievement - ' + (props.goal?.goal_title ?? ''),
  //  curveType: "function",
  //  legend: { position: "bottom" },
  //  colors: ["#0000DF", "#ff0000", "#FFBF00", "#606060"],
  //  series: {
  //    0: { lineDashStyle: [0], lineWidth: 3 },
  //    1: { lineDashStyle: [0], lineWidth: 3 },
  //    2: { lineDashStyle: [0], lineWidth: 3 },
  //    3: { lineDashStyle: [4, 4], lineWidth: 2 },
  //  },
  //  chartArea: { border: '1px solid black', borderRadius: '10px' },
  //  hAxis: { title: 'Date' },
  //  vAxis: { title: 'Progress' },
  //};

  // Generate the Radar Plot
// Register the required components
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

const data = {
  labels: ['Goal A', 'Goal B', 'Goal C', 'Goal D', 'Goal E'],
  datasets: [
    {
      label: 'Target',
      data: [70, 55, 85, 40, 65],
      backgroundColor: 'rgba(54, 162, 235, 0.2)',
      borderColor: 'rgb(54, 162, 235)',
      pointBackgroundColor: 'rgb(54, 162, 235)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgb(54, 162, 235)',
    },
    {
      label: 'Actual',
      data: [60, 35, 45, 30, 63],
      backgroundColor: 'rgba(154, 162, 35, 0.2)',
      borderColor: 'rgb(154, 162, 35)',
      pointBackgroundColor: 'rgb(154, 162, 35)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgb(154, 162, 35)',
    },
    // You can add more datasets here
  ],
};

const options = {
  responsive: true,
  scales: {
    r: {
      beginAtZero: true,
      max: 100,
      ticks: {
        stepSize: 20,
      },
    },
  },
};

return (
    <div>
      {loaded ? (
        <>
          <div style={{ maxWidth: 600, margin: '0 auto' }}>
             <div className="dqt-summary">{summary}</div>
             <Radar data={data} options={options} />
          </div>
        </>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default ReviewGoalRM;
